<template>
  <div>
    <!-- <div>
      <Breadcrumbs
        :extraBreadcrumb="extraBreadcrumbItems"
        :class="breadcrumbClass"
      />
    </div> -->
    <br />
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title class="headline font-weight-bold"> Smart Desk Report </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              rounded
              required
              v-model="selected_ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              @change="onChangeAy()"
            >
              <template #label>
                Academic year <span style="color: red">*</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              rounded
              required
              v-model="selected_section"
              :items="section_list"
              item-text="name"
              item-value="id"
              outlined
              multiple
              @change="getStandardFromSection()"
              :loading="standard_loading"
            >
              <template #label>
                Section <span style="color: red">*</span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item @mousedown.prevent>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="selected_all_section"
                      @change="toggle_section()"
                    >
                      <template #label
                        ><span class="ml-8">Select All</span>
                      </template>
                    </v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="3" v-if="selected_section">
            <v-expand-x-transition>
              <v-select
                v-show="standard_list.length > 0"
                rounded
                required
                v-model="selected_standard"
                :items="standard_list"
                item-text="standard"
                item-value="id"
                outlined
                multiple
                @change="getDivisionByStandard()"
                :loading="division_loading"
              >
                <template #label>
                  Standard <span style="color: red">*</span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item @mousedown.prevent>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selected_all_standard"
                        @change="toggle_standard()"
                      >
                        <template #label
                          ><span class="ml-8">Select All</span>
                        </template>
                      </v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-expand-x-transition>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-expand-x-transition>
              <v-autocomplete
                v-show="division_list.length > 0 && standard_list.length > 0"
                rounded
                required
                v-model="selected_division"
                :items="division_list"
                item-text="div_name"
                item-value="id"
                outlined
                multiple
                @change="getTeacherByStanadardAndDivision()"
                :loading="teacher_loading"
              >
                <template #label>
                  Division <span style="color: red">*</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.div_name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ selected_division.length - 1 }} others)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item @mousedown.prevent>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selected_all_division"
                        @change="toggle_division()"
                      >
                        <template #label
                          ><span class="ml-8">Select All</span>
                        </template>
                      </v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-expand-x-transition>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-expand-x-transition>
              <v-autocomplete
                v-show="teacher_list.length > 0"
                rounded
                required
                v-model="selected_teacher"
                :items="teacher_list"
                item-text="name"
                item-value="id"
                outlined
                multiple
                @change="getCourseByTeacher()"
                :loading="course_loading"
              >
                <template #label>
                  Teacher <span style="color: red">*</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ selected_teacher.length - 1 }} others)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item @mousedown.prevent>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selected_all_teacher"
                        @change="toggle_teacher()"
                      >
                        <template #label
                          ><span class="ml-8">Select All</span>
                        </template>
                      </v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-expand-x-transition>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-expand-x-transition>
              <v-autocomplete
                v-show="course_list.length > 0"
                rounded
                required
                v-model="selected_course"
                :items="course_list"
                item-text="name"
                item-value="id"
                outlined
                multiple
                @change="getChapterByCourse()"
                :loading="chapter_loading"
              >
                <template #label>
                  Course <span style="color: red">*</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ selected_course.length - 1 }} others)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item @mousedown.prevent>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selected_all_course"
                        @change="toggle_course()"
                      >
                        <template #label
                          ><span class="ml-8">Select All</span>
                        </template>
                      </v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-expand-x-transition>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-expand-x-transition>
              <v-autocomplete
                v-show="chapter_list.length > 0"
                rounded
                required
                v-model="selected_chapter"
                :items="chapter_list"
                item-text="name"
                item-value="id"
                outlined
                multiple
                @change="getStudentByDivision()"
                :loading="student_loading"
              >
                <template #label>
                  chapter <span style="color: red">*</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ selected_chapter.length - 1 }} others)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item @mousedown.prevent>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selected_all_chapter"
                        @change="toggle_chapter()"
                      >
                        <template #label
                          ><span class="ml-8">Select All</span>
                        </template>
                      </v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-expand-x-transition>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-expand-x-transition>
              <v-autocomplete
                v-show="student_list.length > 0"
                rounded
                required
                v-model="selected_student"
                :items="student_list"
                item-text="name"
                item-value="lid"
                outlined
                @change="table_data = []"
              >
                <template #label>
                  Student <span style="color: red">*</span>
                </template>
              </v-autocomplete>
            </v-expand-x-transition>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-btn
            class="primary"
            :loading="getSmartDeskReport_loading"
            @click="getSmartDeskReport()"
            >Fetch</v-btn
          >
        </v-row>
      </v-card-text>
    </v-card>
    <br />
    <v-card v-if="table_data.length > 0" class="pa-5">
      <v-row class="justify-space-between">
        <v-col cols="12" sm="6" md="3">
          <v-btn           
            rounded
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'Smart Desk Report')"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >          
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field outlined v-model="search" label="Search"></v-text-field>
        </v-col>
      </v-row>
      <div id="my-table-id">
        <div v-if="org_basic_data">
          <v-row dense justify="center">
            <v-col
              cols="12"
              sm="4"
              md="2"
              v-if="org_basic_data.trust_logo"
              align="center"
            >
              <img
                :src="org_basic_data.trust_logo"
                alt="logo"
                class="trust-logo"
                width="200"
                height="120"
              />
            </v-col>
            <v-col cols="12" sm="4" md="8">
              <center>
                <h2 v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</h2>
                <h3 v-if="org_basic_data.school_name">{{ org_basic_data.school_name }}</h3>
                <span v-if="org_basic_data.address"
                  ><strong>Address : </strong>{{ org_basic_data.address }}</span
                >
                <br />
                <span v-if="org_basic_data.phone"
                  ><strong>Phone : </strong>{{ org_basic_data.phone }}
                </span>
                <br />
                <span v-if="org_basic_data.email"
                  ><strong>Email : </strong>{{ org_basic_data.email }}
                </span>
                <br />
                <span v-if="org_basic_data.website"
                  ><strong>Website : </strong>{{ org_basic_data.website }}
                </span>
                <br />
              </center>
            </v-col>
            <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo">
              <img
                :src="org_basic_data.school_logo"
                width="200"
                height="120"
                alt="logo"
                class="schl-logo"
              />
            </v-col>
          </v-row>
        </div>
        <br />
        <v-data-table
          v-if="selected_student == 'ALL'"
          :items="table_data"
          :headers="headers"
          :search="search"
          id="export1"
        ></v-data-table>
        <v-data-table
          v-else
          :items="table_data"
          :headers="headers1"
          :search="search"
          id="export2"
        ></v-data-table>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      extraBreadcrumbItems: [],
      breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      snackbar_msg: null,
      ay_list: [],
      selected_ay: "",
      selected_section: "",
      selected_all_section: false,
      section_list: [],
      selected_standard: [],
      standard_list: [],
      selected_all_standard: false,
      standard_loading: false,
      selected_division: [],
      division_list: [],
      selected_all_division: false,
      division_loading: false,
      selected_teacher: [],
      teacher_list: [],
      selected_all_teacher: false,
      teacher_loading: false,
      selected_course: [],
      course_list: [],
      selected_all_course: false,
      course_loading: false,
      selected_chapter: [],
      chapter_list: [],
      selected_all_chapter: false,
      chapter_loading: false,
      selected_student: [],
      student_list: [],
      selected_all_student: false,
      student_loading: false,
      getSmartDeskReport_loading: false,
      table_data: [],
      headers: [
        { text: "Sr.No.", value: "srno" },
        { text: "Academic Year", value: "academicyear_name" },
        { text: "Section", value: "section_name" },
        { text: "Standard", value: "standard_name" },
        { text: "Division", value: "division_name" },
        { text: "Teacher", value: "instructor_name" },
        { text: "Subject", value: "course_name" },
        { text: "Chapter", value: "chapter_name" },
        { text: "Total Response", value: "total_response" },
        { text: "Correct", value: "correct_count" },
        { text: "Wrong", value: "wrong_count" },
        { text: "Correct %", value: "correct_percent" },
        { text: "Wrong %", value: "wrong_percent" },
      ],
      headers1: [
        { text: "Sr.No.", value: "srno" },
        { text: "Academic Year", value: "academicyear_name" },
        { text: "PRN", value: "prn" },
        { text: "Name", value: "student_name" },
        { text: "Section", value: "section_name" },
        { text: "Standard", value: "standard_name" },
        { text: "Division", value: "division_name" },
        { text: "Teacher", value: "instructor_name" },
        { text: "Subject", value: "course_name" },
        { text: "Chapter", value: "chapter_name" },
        { text: "Total Response", value: "total_response" },
        { text: "Correct", value: "correct_count" },
        { text: "Wrong", value: "wrong_count" },
        { text: "Correct %", value: "correct_percent" },
        { text: "Wrong %", value: "wrong_percent" },
      ],
      search: "",
      org_basic_data: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    fnExcelReport(id, name) {
      this.$nextTick(() => {
        const divToExport = document.getElementById(id);
        if (!divToExport) return;
        const clonedDiv = divToExport.cloneNode(true);
        clonedDiv.querySelectorAll("img").forEach((img) => img.remove());
        clonedDiv.querySelectorAll(".no-export").forEach((el) => el.remove());
        clonedDiv
          .querySelectorAll(".v-data-footer")
          .forEach((el) => el.remove());

        const html = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style>
            table, th, td { border: 1px solid black; border-collapse: collapse; }
            th, td { padding: 5px; text-align: center; }
          </style>
        </head>
        <body>${clonedDiv.innerHTML}</body>
      </html>`;

        const blob = new Blob([html], {
          type: "application/vnd.ms-excel",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = name + ".xls";
        a.click();
        URL.revokeObjectURL(url);
      });
    },
    getSmartDeskReport() {
      if (!this.selected_ay) {
        this.showSnackbar("red", "Please Select Ay");
        return;
      }
      if (
        !(
          Array.isArray(this.selected_section) &&
          this.selected_section.length > 0
        )
      ) {
        this.showSnackbar("red", "Please Select Section");
        return;
      }
      if (
        !(
          Array.isArray(this.selected_standard) &&
          this.selected_standard.length > 0
        )
      ) {
        this.showSnackbar("red", "Please Select standard");
        return;
      }
      if (
        !(
          Array.isArray(this.selected_division) &&
          this.selected_division.length > 0
        )
      ) {
        this.showSnackbar("red", "Please Select Division");
        return;
      }
      if (
        !(
          Array.isArray(this.selected_teacher) &&
          this.selected_teacher.length > 0
        )
      ) {
        this.showSnackbar("red", "Please Select teacher");
        return;
      }
      if (
        !(
          Array.isArray(this.selected_course) && this.selected_course.length > 0
        )
      ) {
        this.showSnackbar("red", "Please Select Course");
        return;
      }
      if (
        !(
          Array.isArray(this.selected_chapter) &&
          this.selected_chapter.length > 0
        )
      ) {
        this.showSnackbar("red", "Please Select Chapter");
        return;
      }
      if (!this.selected_student) {
        this.showSnackbar("red", "Please Select Student");
        return;
      }
      const data = {
        selected_ay: this.selected_ay,
        selected_section: this.selected_section,
        selected_standard: this.selected_standard,
        selected_division: this.selected_division,
        selected_teacher: this.selected_teacher,
        selected_course: this.selected_course,
        selected_chapter: this.selected_chapter,
        selected_student: this.selected_student,
      };
      this.getSmartDeskReport_loading = true;
      axios.post("/liveClass/getSmartDeskReport", data).then((res) => {
        if (res.data.flag === "YES") {
          this.getSmartDeskReport_loading = false;
          this.table_data = res.data.table_data;
          this.org_basic_data = res.data.org_basic_data;
          for (var i in this.table_data) {
            this.table_data[i]["srno"] = parseInt(i.toString()) + 1;
            if (
              this.table_data[i]["total_response"] != 0 ||
              this.table_data[i]["correct_count"] != 0
            )
              this.table_data[i]["correct_percent"] = (
                (this.table_data[i]["correct_count"] /
                  this.table_data[i]["total_response"]) *
                100
              ).toFixed(2);
            if (
              this.table_data[i]["wrong_count"] != 0 ||
              this.table_data[i]["total_response"] != 0
            )
              this.table_data[i]["wrong_percent"] = (
                (this.table_data[i]["wrong_count"] /
                  this.table_data[i]["total_response"]) *
                100
              ).toFixed(2);
          }
        } else {
          this.getSmartDeskReport_loading = false;
          this.showSnackbar("red", res.data.msg);
        }
      });
    },
    onChangeAy() {
      (this.selected_section = ""),
        (this.selected_all_section = false),
        (this.selected_standard = []);
      this.standard_list = [];
      this.selected_all_standard = false;
      this.standard_loading = false;
      this.table_data = [];
      this.selected_division = [];
      this.division_list = [];
      this.selected_all_division = false;
      this.division_loading = false;
      this.selected_teacher = [];
      this.teacher_list = [];
      this.selected_all_teacher = false;
      this.teacher_loading = false;
      this.selected_course = [];
      this.course_list = [];
      this.selected_all_course = false;
      this.course_loading = false;
      this.selected_chapter = [];
      (this.chapter_list = []), (this.selected_all_chapter = false);
      this.chapter_loading = false;
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = false;
      this.table_data = [];
    },
    getStudentByDivision() {
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = false;
      this.table_data = [];
      this.division_loading = false;
      this.teacher_loading = false;
      this.course_loading = false;
      this.chapter_loading = false;
      this.student_loading = true;
      axios
        .post("/liveClass/getLearnersByAYAndDivisionOffering", {
          divisionOfferingIds: this.selected_division,
          ay: this.selected_ay,
        })
        .then((res) => {
          if (res.data.flag === "Yes") {
            this.student_list = res.data.learner_list;
            if (
              Array.isArray(this.student_list) &&
              this.student_list.length > 0
            ) {
              this.student_list.unshift({ id: "ALL", name: "ALL" });
              this.selected_student = "ALL";
            }
            this.student_loading = false;
          } else {
            this.showSnackbar("red", res.data.msg);
            this.student_loading = false;
          }
        });
    },
    getChapterByCourse() {
      if (this.selected_course.length == 0) {
        this.chapter_list = [];
        return;
      }
      this.selected_chapter = [];
      (this.chapter_list = []), (this.selected_all_chapter = false);
      this.chapter_loading = false;
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = false;
      this.table_data = [];
      this.division_loading = false;
      this.teacher_loading = false;
      this.course_loading = false;
      this.chapter_loading = true;
      axios
        .post("/liveClass/chapter", {
          crs_id: this.selected_course,
        })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.chapter_list = res.data.chapter_list;
            this.chapter_loading = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            this.chapter_loading = false;
          }
        });
    },
    getCourseByTeacher() {
      if (this.selected_teacher.length == 0) {
        this.course_list = [];
        return;
      }
      this.selected_course = [];
      this.course_list = [];
      this.selected_all_course = false;
      this.course_loading = false;
      this.selected_chapter = [];
      (this.chapter_list = []), (this.selected_all_chapter = false);
      this.chapter_loading = false;
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = false;
      this.table_data = [];
      this.division_loading = false;
      this.teacher_loading = false;
      this.course_loading = true;
      axios
        .post("/liveClass/getCoursesByInstructorForReport", {
          teacher_ids: this.selected_teacher,
          standard_ids: this.selected_standard,
          division_off_ids: this.selected_division,
          selected_ay: this.selected_ay,
        })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.course_list = res.data.course_list;
            this.course_loading = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            this.course_loading = false;
          }
        });
    },
    getTeacherByStanadardAndDivision() {
      if (this.selected_division.length == 0) {
        this.teacher_list = [];
        return;
      }
      this.selected_teacher = [];
      this.teacher_list = [];
      this.selected_all_teacher = false;
      this.teacher_loading = false;
      this.selected_course = [];
      this.course_list = [];
      this.selected_all_course = false;
      this.course_loading = false;
      this.selected_chapter = [];
      (this.chapter_list = []), (this.selected_all_chapter = false);
      this.chapter_loading = false;
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = false;
      this.table_data = [];
      this.division_loading = false;
      this.teacher_loading = true;

      axios
        .post("/liveClass/getCourseOfferingInstructorsForReport", {
          standard_ids: this.selected_standard,
          division_off_ids: this.selected_division,
          selected_ay: this.selected_ay,
        })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.teacher_list = res.data.inst_list;
            this.teacher_loading = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            this.teacher_loading = false;
          }
        });
    },
    getDivisionByStandard() {
      if (this.selected_standard.length == 0) {
        this.division_list = [];
        return;
      }
      this.selected_division = [];
      this.division_list = [];
      this.selected_all_division = false;
      this.division_loading = false;
      this.selected_teacher = [];
      this.teacher_list = [];
      this.selected_all_teacher = false;
      this.teacher_loading = false;
      this.selected_course = [];
      this.course_list = [];
      this.selected_all_course = false;
      this.course_loading = false;
      this.selected_chapter = [];
      (this.chapter_list = []), (this.selected_all_chapter = false);
      this.chapter_loading = false;
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = false;
      this.table_data = [];
      this.division_loading = true;
      axios
        .post("/liveClass/getDivOffByStandardForReport", {
          standard_ids: this.selected_standard,
          selected_ay: this.selected_ay,
        })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.division_list = res.data.division_list;
            this.division_loading = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            this.division_loading = false;
          }
        });
    },
    getStandardFromSection() {
      if (this.selected_section.length == 0) {
        this.standard_list = [];
        return;
      }
      const data = {
        section_ids: this.selected_section,
      };
      this.selected_standard = [];
      this.standard_list = [];
      this.selected_all_standard = false;
      this.standard_loading = false;
      this.table_data = [];
      this.selected_division = [];
      this.division_list = [];
      this.selected_all_division = false;
      this.division_loading = false;
      this.selected_teacher = [];
      this.teacher_list = [];
      this.selected_all_teacher = false;
      this.teacher_loading = false;
      this.selected_course = [];
      this.course_list = [];
      this.selected_all_course = false;
      this.course_loading = false;
      this.selected_chapter = [];
      (this.chapter_list = []), (this.selected_all_chapter = false);
      this.chapter_loading = false;
      this.selected_student = [];
      this.student_list = [];
      this.selected_all_student = false;
      this.student_loading = false;
      this.getSmartDeskReport_loading = false;
      this.standard_loading = true;
      axios.post("/liveClass/getStandardBySection", data).then((res) => {
        if (res.data.flag == "YES") {
          this.standard_list = res.data.standard_list;
          this.standard_loading = false;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          this.standard_loading = false;
        }
      });
    },
    toggle_chapter() {
      this.$nextTick().then(() => {
        if (this.selected_all_chapter) {
          this.selected_chapter = [];
          for (var x in this.chapter_list) {
            this.selected_chapter.push(this.chapter_list[x].id);
          }
          this.getStudentByDivision();
        } else {
          this.selected_chapter = [];
        }
      });
    },
    toggle_course() {
      this.$nextTick().then(() => {
        if (this.selected_all_course) {
          this.selected_course = [];
          for (var x in this.course_list) {
            this.selected_course.push(this.course_list[x].id);
          }
          this.getChapterByCourse();
        } else {
          this.selected_course = [];
        }
      });
    },
    toggle_teacher() {
      this.$nextTick().then(() => {
        if (this.selected_all_teacher) {
          this.selected_teacher = [];
          for (var x in this.teacher_list) {
            this.selected_teacher.push(this.teacher_list[x].id);
          }
          this.getCourseByTeacher();
        } else {
          this.selected_teacher = [];
        }
      });
    },
    toggle_division() {
      this.$nextTick().then(() => {
        if (this.selected_all_division) {
          this.selected_division = [];
          for (var x in this.division_list) {
            this.selected_division.push(this.division_list[x].id);
          }
          this.getTeacherByStanadardAndDivision();
        } else {
          this.selected_division = [];
        }
      });
    },
    toggle_section() {
      this.$nextTick().then(() => {
        if (this.selected_all_section) {
          this.selected_section = [];
          for (var x in this.section_list) {
            this.selected_section.push(this.section_list[x].id);
          }
          this.getStandardFromSection();
        } else {
          this.selected_section = [];
        }
      });
    },
    toggle_standard() {
      this.$nextTick().then(() => {
        if (this.selected_all_standard) {
          this.selected_standard = [];
          for (var x in this.standard_list) {
            this.selected_standard.push(this.standard_list[x].id);
          }
          this.getDivisionByStandard();
        } else {
          this.selected_standard = [];
        }
      });
    },
    init() {
      axios.post("/liveClass/getAllDataForReport").then((res) => {
        if (res.data.flag == "YES") {
          this.ay_list = res.data.ay_data;
          if (Array.isArray(this.ay_list) && this.ay_list.length > 0) {
            this.selected_ay = res.data.cay.id;
          }
          this.section_list = res.data.section_list_all;
        } else {
          this.showSnackbar("red", res.data.snackbar);
        }
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

